// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aQu_","left":"styles_left__1LznO","desktopActions":"styles_desktopActions__1t1wm","title":"styles_title__5_tfB"};